import Vue from "vue";
import VueRouter from "vue-router";
import Acl from "vue-acl3";
import Dashboard  from "@/components/Dashboard.vue";
import Semacesso from "../views/Semacesso.vue";
import Pedidos from  "../views/Pedidos.vue";
import Entrega from  "../views/EntregaProgramada.vue";
import Monitor from "../views/Monitor.vue";
import MonitorCardapio from "../views/MonitorCardapio.vue";

import Produtos from "../views/Produtos.vue";
import Promocao from "../views/Promocao.vue";
import Categorias from  "../views/Categorias.vue";
import PlanoCategorias from  "../views/PlanoCategorias.vue";
import EnderecosRetirada from "../views/EnderecosRetirada.vue";
import Configuracao from "../views/Configuracao.vue";
import Usuarios from "../views/Usuarios.vue";
import TaxaBairro from "../views/TaxaBairro.vue";
import TaxaDistancia from "../views/TaxaDistancia.vue";
import Bandeiras from "../views/Bandeiras.vue";
import GerarQrcode from "../views/GerarQrcode.vue";
import PerfilVendas from "../views/PerfilVendas.vue";
import MontagemCardapio from "../views/MontagemCardapio.vue";
import MontagemEtapa from "../views/MontagemEtapa.vue";
import MontagemObs from "../views/MontagemObs.vue"; 
import MontagemItem from "../views/MontagemItem.vue"; 
import About from "../views/About.vue"; 

Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "login",

    component: () =>
      import(
        "@/components/Login.vue"
      ) /*import( /* webpackChunkName: "about"  './Login.vue')*/ ,
  },
  {
    path: "/redefinir_senha/:token",
    name: "redefinir_senha",
    props: true,
    component: () =>
      import(
        "@/components/RedefinirSenha.vue"
      ) /*import( /* webpackChunkName: "about"  './Login.vue')*/ ,
  },

  {
    path: "/dashboard",
    name: "Dashboard",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Dashboard ,
    children: [{
        path: "semacesso",
        name: "Semacesso",
        component: Semacesso ,

      },
      {
        path: "pedidos",
        name: "pedidos",
        component: Pedidos,
        meta: {
          permission: "admin.loja|pedidos.list",
          fail: "semacesso"
        },
      },
      {
        path: "about",
        name: "about",
        component: About,
        meta: {
          permission: "admin.loja|pedidos.list",
          fail: "semacesso"
        },
      },
      {
        path: "entrega",
        name: "entrega",
        component: Entrega,
        meta: {
          permission: "admin.loja",
          fail: "semacesso"
        },
      },
      {
        path: "monitor",
        name: "monitor",
        meta: {
          permission: 'admin.loja|acompanhamento.view',
          fail: "semacesso"
        },
        component: Monitor,
      },
      {
        path: "monitor_cardapio",
        name: "monitor_cardapio",
        meta: {
          permission: 'admin.loja|cardapios.view',
          fail: "semacesso"
        },
        component: MonitorCardapio,
      },
      {
        name: "configuracao",
        path: "configuracao",
        component: Configuracao,
        meta: {
          permission: "admin.loja|config.view",
          fail: "semacesso"
        },
      },
      {
        name: "usuarios",
        path: "usuarios",
        component: Usuarios,
        meta: {
          permission: "admin.loja|user.view",
          fail: "semacesso"
        },
      },
      {
        name: "categorias",
        path: "categorias",
        meta: {
          permission: "admin.loja|categorias.view",
          fail: "semacesso"
        },
        component: Categorias,
      },
      {
        name: "plano_categorias",
        path: "plano_categorias",
        meta: {
          permission: "admin.loja|plano_categorias.view",
          fail: "semacesso"
        },
        component: PlanoCategorias,
      },
      {
        path: "produtos",
        name: "produtos",
        meta: {
          permission: "admin.loja|produtos.view",
          fail: "semacesso"
        },
        component: Produtos,
      },
       {
        path: "promocao",
        name: "promocao",
        meta: {
          permission: "admin.loja|promocao.view",
          fail: "semacesso"
        },
        component: Promocao,
      },
      {
        path: "taxa_entrega_bairro",
        name: "taxa_entrega_bairro",
        meta: {
          permission: "admin.loja|taxa_entrega_bairro.create",
          fail: "semacesso"
        },
        component: TaxaBairro,
      },
      {
        path: "taxa_entrega_distancia",
        name: "taxa_entrega_distancia",
        meta: {
          permission: "admin.loja|taxa_entrega_distancia.create",
          fail: "semacesso"
        },
        component: TaxaDistancia,
      },
      {
        path: "end_retirada",
        name: "end_retirada",
        meta: {
          permission: "admin.loja|end_retirada.view",
          fail: "semacesso"
        },
        component: EnderecosRetirada,
      },
       {
        path: "gerar_qrcode",
        name: "gerar_qrcode",
        meta: {
          permission: "admin.loja",
          fail: "semacesso"
        },
        component: GerarQrcode,
      },
       {
        path: "perfil_vendas",
        name: "perfil_vendas",
        meta: {
          permission: "admin.loja",
          fail: "semacesso"
        },
        component: PerfilVendas,
      },
      {
        path: "bandeiras_cartao",
        name: "bandeiras_cartao",
        meta: {
          permission: "admin.loja",
          fail: "semacesso"
        },
        component: Bandeiras,
      },
      {
        name: "montagem_cardapio",
        path: "montagem_cardapio",
        component: MontagemCardapio,
        meta: {
          permission: "admin.loja|cardapios.view",
          fail: "semacesso"
        },
      },
      {
        name: "montagem_item",
        path: "montagem_item",
        component: MontagemItem,
        meta: {
          permission: "admin.loja|montagem_item.view",
          fail: "semacesso"
        },
      },
      ,
      {
        name: "montagem_obs",
        path: "montagem_obs",
        component: MontagemObs,
        meta: {
          permission: "admin.loja|montagem_obs.view",
          fail: "semacesso"
        },
      },
      {
        name: "montagem_etapa",
        path: "montagem_etapa",
        component: MontagemEtapa,
        meta: {
          permission: "admin.loja|montagem_etapa.view",
          fail: "semacesso"
        },
      },


    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
Vue.use(Acl, {
  router: router,
  init: window.sessionStorage.getItem("tokenKey"),
});

/*router.beforeEach((to, from, next) => {
  //console.log(window.sessionStorage.getItem("tokenKey"));
  //  this.$access(window.sessionStorage.getItem("tokenKey"));
  next();
});*/
/*if (window.sessionStorage.getItem("permissoes")) {
  Vue.use(Acl, {
    router: router,
    init: window.sessionStorage.getItem("permissoes").split(","),
  });
} else {
  Vue.use(Acl, {
    router: router,
    init: "todos",
  });
}*/

export default router;